export function Activate(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/activate`;
}

export function AddGroup(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/groups`;
}

export function AddResource(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/resources`;
}

export function AddTeam(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/teams`;
}

export function AdvanceTeamsFromGroups(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/bracket/advance`;
}

export function Bracket(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/bracket`;
}

export function BracketView(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/bracket/view`;
}

export function CancelScheduledActivation(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/schedule-activation`;
}

export function Create(organizationID: number): string {
	return `/v1/organizations/${organizationID}/tournaments`;
}

export function CreateBracketGame(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/bracket/games`;
}

export function Delete(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}`;
}

export function DeleteBracketGame(organizationID: number, tournamentID: number, bracketGameID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/bracket/games/${bracketGameID}`;
}

export function DeleteGame(organizationID: number, tournamentID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/games/${gameID}`;
}

export function DeleteGames(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/games/delete`;
}

export function DeleteGroup(organizationID: number, tournamentID: number, groupID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/groups/${groupID}`;
}

export function Duplicate(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/duplicate`;
}

export function FixtureResourceConflict(organizationID: number, tournamentID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/games/${gameID}/resource-conflict`;
}

export function GenerateBracket(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/bracket`;
}

export function GenerateFixtures(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/generate-fixtures`;
}

export function GenerateGroups(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/generate-groups`;
}

export function Index(organizationID: number): string {
	return `/v1/organizations/${organizationID}/tournaments`;
}

export function LatestResults(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/matches/latest`;
}

export function ListFixtures(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/fixtures`;
}

export function ListPlayoffRounds(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/playoff-rounds`;
}

export function ListResources(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/resources`;
}

export function ListTeamVenues(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/team-venues`;
}

export function ListTeams(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/teams`;
}

export function Model(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/model`;
}

export function Participants(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/participants`;
}

export function PublicBracketView(publicID: string): string {
	return `/v1/tournaments/public/${publicID}/bracket/view`;
}

export function PublicFixtures(publicID: string): string {
	return `/v1/tournaments/public/${publicID}/fixtures`;
}

export function PublicLatestResults(publicID: string): string {
	return `/v1/tournaments/public/${publicID}/matches/latest`;
}

export function PublicParticipants(publicID: string): string {
	return `/v1/tournaments/public/${publicID}/participants`;
}

export function PublicSeries(publicID: string): string {
	return `/v1/tournaments/public/${publicID}/bracket/series`;
}

export function PublicShow(publicID: string): string {
	return `/v1/tournaments/public/${publicID}`;
}

export function PublicStandingsGroups(publicID: string): string {
	return `/v1/tournaments/public/${publicID}/standings/groups`;
}

export function PublicStandingsTable(publicID: string): string {
	return `/v1/tournaments/public/${publicID}/standings/table`;
}

export function PublicUpcomingMatches(publicID: string): string {
	return `/v1/tournaments/public/${publicID}/matches/upcoming`;
}

export function RegenerateBracketRound(organizationID: number, tournamentID: number, roundNumber: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/playoff-rounds/${roundNumber}/regenerate`;
}

export function RemoveGroupTeam(organizationID: number, tournamentID: number, groupID: number, teamID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/groups/${groupID}/teams/${teamID}`;
}

export function RemoveResource(organizationID: number, tournamentID: number, resourceID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/resources/${resourceID}`;
}

export function RemoveTeam(organizationID: number, tournamentID: number, teamID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/teams/${teamID}`;
}

export function RemoveTeamVenue(organizationID: number, tournamentID: number, teamID: number, resourceID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/team-venues/${teamID}/${resourceID}`;
}

export function RemoveTeams(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/teams/remove`;
}

export function RescheduleGames(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/games/reschedule`;
}

export function ScheduleActivation(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/schedule-activation`;
}

export function Series(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/bracket/series`;
}

export function SetPlayoffRounds(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/playoff-rounds`;
}

export function SetResourceAvailability(organizationID: number, tournamentID: number, resourceID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/resources/${resourceID}/availability`;
}

export function SetTeamVenue(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/team-venues`;
}

export function Show(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}`;
}

export function Standings(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/standings`;
}

export function StandingsGroups(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/standings/groups`;
}

export function StandingsTable(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/standings/table`;
}

export function SwapGames(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/games/swap`;
}

export function Unpublish(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/unpublish`;
}

export function UnscheduleGames(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/games/unschedule`;
}

export function UpcomingMatches(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/matches/upcoming`;
}

export function Update(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}`;
}

export function UpdateBracketGame(organizationID: number, tournamentID: number, bracketGameID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/bracket/games/${bracketGameID}`;
}

export function UpdateFixture(organizationID: number, tournamentID: number, gameID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/games/${gameID}`;
}

export function UpdateGroups(organizationID: number, tournamentID: number): string {
	return `/v1/organizations/${organizationID}/tournaments/${tournamentID}/groups`;
}

